import FormValidator from "@web/vpt-assets/assets/js/utilities/validations/formValidator";

export default class RememberPasswordHandler {
    constructor({rememberPassword}) {
        this.form = document.querySelector('#form-user-remember-password');
        if (!this.form) {
            return;
        }
        this.formValidator = new FormValidator(this.form, {});
        this.rememberPassword = rememberPassword;
        this.eventDelegation();
    };

    eventDelegation() {
        const emailInput = this.form.querySelector('#email-remember-password')
        if (emailInput) {
            emailInput.addEventListener('inputValidated', (formMessage) => {
                const errorMessage = document.querySelector("#rememberPasswordEmailMessage");
                if (!formMessage.detail.isValid && formMessage.detail.failedValidator == 'email' && errorMessage) {
                    errorMessage.style.display = "block";
                } else {
                    errorMessage.style.display = "none";
                }
            });
        }

        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (this.formValidator.validateForm()) {
                const formButton = this.form.querySelector('[data-entity="form-user-remember-password-button"]');
                if (formButton) {
                    formButton.disabled = true;
                    formButton.classList.add('disabled');
                }

                const response = await this.rememberPassword();
                if (!response.status || !response.message) return;

                const responseContainer = document.querySelector('[data-container="form-response-form-user-remember-password"]');
                responseContainer.style.display = '';
                document.querySelector('[name="remember-pass-form"]').style.display = 'none';

                const responseTitleContainer = responseContainer.querySelector('[data-response-form-title]');
                responseTitleContainer.innerHTML = response.title;

                const responseMsgContainer = responseContainer.querySelector('[data-response-form-description]');
                responseMsgContainer.innerHTML = response.message;

                const responseFormDescriptionList = responseContainer.querySelector('[data-response-form-description-list]');
                const responseFormDescriptionListContainer = document.createElement('div');
                if (responseFormDescriptionList) {
                    if (response.messageList) {
                        if (response.messageList.title) {
                            const title = document.createElement('span');
                            title.classList.add('text-weight-semibold', 'mt-1');
                            title.innerHTML = response.messageList.title;
                            responseFormDescriptionListContainer.appendChild(title);
                        }

                        const listContainer = document.createElement('div');
                        listContainer.classList.add('d-flex', 'flex-column');
                        if (response.messageList.items) {
                            response.messageList.items.forEach((item) => {
                                const liContainer = document.createElement('div');
                                liContainer.classList.add('d-flex', 'align-items-center', 'gap-2');
                                const liDot = document.createElement('span');
                                const li = document.createElement('span');
                                liDot.innerHTML = '·';
                                li.innerHTML = item;
                                liContainer.appendChild(liDot);
                                liContainer.appendChild(li);
                                listContainer.appendChild(liContainer);
                            });
                        }

                        responseFormDescriptionListContainer.appendChild(listContainer);
                        responseFormDescriptionList.innerHTML = responseFormDescriptionListContainer.innerHTML;
                        responseFormDescriptionList.style.display = '';
                    } else {
                        responseFormDescriptionList.style.display = 'none';
                    }
                }

                const forgotPasswordButton = responseContainer.querySelector('[name="forgot-password"]');
                const loginButton = responseContainer.querySelector('[data-open="loginAnchor"]');
                if (!forgotPasswordButton || !loginButton) return;
                if (response.status === 400) {
                    loginButton.style.display = 'none';
                    forgotPasswordButton.style.display = '';
                } else {
                    forgotPasswordButton.style.display = 'none';
                    loginButton.style.display = '';
                }
            }
        });
    }
}
